import { useState } from 'react';
import {
  Dropdown,
  FlexCell,
  FlexRow,
  LinkButton,
  SearchInput,
} from '@epam/promo';
import { IDropdownToggler } from '@epam/uui-core';
import { ReactComponent as filterIcon } from '@epam/assets/icons/common/content-filtration-18.svg';
import css from './TaskFilters.module.scss';

export const TaskFilters = () => {
  const [value, onValueChange] = useState<string>('');

  return (
    <FlexRow cx={css.taskInput__container} spacing="6">
      <FlexCell cx={css.search__container} grow={1}>
        <SearchInput
          debounceDelay={1000}
          inputCx={css.search__input}
          placeholder="Search"
          value={value}
          onValueChange={(newValue: string) => onValueChange(newValue)}
        />
      </FlexCell>
      <Dropdown
        placement="right-start"
        renderBody={() => null}
        renderTarget={({
          isOpen,
          isDropdown,
          toggleDropdownOpening,
          isInteractedOutside,
          ref,
        }: IDropdownToggler) => (
          <LinkButton
            ref={ref}
            cx={css['taskInput__filter-icon']}
            icon={filterIcon}
            isDropdown={isDropdown}
            isInteractedOutside={isInteractedOutside}
            isOpen={isOpen}
            toggleDropdownOpening={toggleDropdownOpening}
          />
        )}
      />
    </FlexRow>
  );
};
